import { render, staticRenderFns } from "./hotSpringDetail.vue?vue&type=template&id=19b766bb&scoped=true&"
import script from "./hotSpringDetail.vue?vue&type=script&lang=js&"
export * from "./hotSpringDetail.vue?vue&type=script&lang=js&"
import style0 from "./hotSpringDetail.vue?vue&type=style&index=0&id=19b766bb&scoped=true&lang=less&"
import style1 from "./hotSpringDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b766bb",
  null
  
)

export default component.exports